import { FC, ReactNode, useState } from 'react';
import ImageComponent from '../ImageComponent';
import { useField, useFormikContext } from 'formik';
import { ImageListType } from 'react-images-uploading';
import { BasicSettingsType } from '../../redux/types/mainObjectTypes';

type FormikImageWrapperProps = {
  photoFormikName: string;
  newPhotoFormikName: string;
  noImageIcon: ReactNode;
  requirementsText: string | string[];
  newImageBtnTitle?: string;
  maxNumber?: number;
  maxFileSize?: number;
  acceptType?: string[];
  resolutionType?: 'less' | 'more' | 'absolute' | 'ratio';
  resolutionWidth?: number;
  resolutionHeight?: number;
  allowNonImageType?: boolean;
  orientation?: 'vertical' | 'horizontal';
  alt?: string;
  classNameImgWrapper?: string;
  classNameContainer?: string;
};

const FormikImageWrapper: FC<FormikImageWrapperProps> = ({
  photoFormikName,
  newPhotoFormikName,
  ...props
}) => {
  const { setFieldValue, setFieldError, values, errors, touched } =
    useFormikContext<BasicSettingsType>();

  const fieldValue = values[
    newPhotoFormikName as keyof BasicSettingsType
  ] as ImageListType;
  const newFieldValue = (values[photoFormikName as keyof BasicSettingsType] ??
    null) as string | null;
  const errText = (errors[newPhotoFormikName as keyof BasicSettingsType] ??
    undefined) as string | undefined;

  const [field, meta, helpers] = useField<string>(photoFormikName);

  // const setValue = (val: string) => {
  //   helpers.setValue(val)
  // }

  const setError: React.Dispatch<React.SetStateAction<string>> = (val) => {
    if (typeof val === 'function') {
      const resolved = val(meta.error || '');

      setFieldError(newPhotoFormikName, resolved || undefined); // удаляем ошибку, если resolved пустой
    } else {
      setFieldError(newPhotoFormikName, val || undefined); // удаляем ошибку, если val пустой
    }
  };
  return (
    <ImageComponent
      image={newFieldValue}
      newImage={fieldValue}
      setNewImage={(val) => setFieldValue(newPhotoFormikName, val)}
      setImage={(val) => setFieldValue(photoFormikName, val)}
      setError={setError}
      errText={errText}
      {...props}
    />
  );
};

export default FormikImageWrapper;
